import FilterInput from "@/components/customViews/filters/FilterInput";
import FilterInputWithSuggestions from "@/components/FilterInputWithSuggestions";
import { verifyEmail } from "@/lib/utils";
import { X } from "lucide-react";

type StringsFilterProps = {
    label: string;
    values: string[];
    setValues: (values: string[]) => void;
    withContactSuggestions?: boolean;
};

const StringsFilter = ({
    label,
    values,
    setValues,
    withContactSuggestions = false,
}: StringsFilterProps) => (
    <div>
        <p>{label}</p>
        <div className="flex flex-wrap gap-2 rounded-md bg-white p-3">
            {values?.map((value) => (
                <p
                    key={value}
                    className="flex w-fit items-center gap-1 rounded-md bg-surface-activeFg px-2 py-1 text-xs"
                >
                    {value}
                    <button
                        onClick={() => {
                            setValues?.(values?.filter((v) => v !== value));
                        }}
                        type="button"
                    >
                        <X className="cursor-pointer text-gray-500" size={14} />
                    </button>
                </p>
            ))}
            {withContactSuggestions ? (
                <FilterInputWithSuggestions
                    setValues={setValues}
                    validator={verifyEmail}
                    values={values}
                />
            ) : (
                <FilterInput setValues={setValues} values={values} />
            )}
        </div>
    </div>
);

export default StringsFilter;
